var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4"},[_c('h1',{staticClass:"mb-4"},[_vm._v("Nouvelle recette")]),_c('RecetteFormulaire',{attrs:{"mode":"create"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }